import { Component, OnInit } from '@angular/core';

export interface WeekData {
  weekNumber: number;
  subjects: string[];
}

export interface SuccessStory {
  image: string;
  label: string;
  name: string;
  achievement: string;
  testimonialHeader: string;
  testimonial: string;
  closingMessage: string;
}

export interface PricingPlan {
  weeks: string;
  features: string[];
  originalPrice: number;
  discount: string;
  finalPrice: number;
}

@Component({
    selector: 'app-eleven-plus-sprint',
    templateUrl: './eleven-plus-sprint.component.html',
    styleUrls: ['./eleven-plus-sprint.component.css'],
    standalone: false
})
export class ElevenPlusSprintComponent implements OnInit {


   weeks: WeekData[] = [
    {
      weekNumber: 1,
      subjects: [
        'Maths - Numbers & Factors (M01)',
        'English Reading Comprehension (ECOMP01)',
        'English Creative Writing (CW01)'
      ]
    },
    {
      weekNumber: 2,
      subjects: [
        'Maths - Decimals  (M02)',
        'English Reading Comprehension (ECOMP02)',
        'English Creative Writing  (CW02)'
      ]
    },
    {
      weekNumber: 3,
      subjects: [
        'Maths - Fractions (M03)',
        'English Creative Writing (CW03)',
        'Reasoning - Verbal & Non Verbal (VRNVR01)'
      ]
    },
    // Add more weeks as needed
    {
      weekNumber: 4,
      subjects: [
        'Maths - Percentage (M04)',
        'English Reading Comprehension (ECOMP03)',
        'English Creative Writing (CW04)'
      ]
    },
    {
      weekNumber: 5,
      subjects: [
        'Maths - Money (M05)',
        'English Reading Comprehension (ECOMP04)',
        'English Creative Writing (CW05)'
      ]
    },
    {
      weekNumber: 6,
      subjects: [
        'Maths - Data Handling (M06)',
        'English Creative Writing  (CW06)',
        'Reasoning - Verbal & Non Verbal (VRNVR02)'
      ]
    },
    {
      weekNumber: 7,
      subjects: [
       'Maths - Day Date Time (M07)',
        'English Reading Comprehension (ECOMP05)',
        'English Creative Writing (CW07)'
      ]
    },
    {
      weekNumber: 8,
      subjects: [
        'Maths - Probability, Ratio and Proportion (M08)',
        'English Reading Comprehension (ECOMP06)',
        'English Creative Writing (CW08)'
      ]
    },
    {
      weekNumber: 9,
      subjects: [
        'Maths - Shapes, Area, Perimeter & Volume Part 01 (M09)',
        'English Reading Comprehension (ECOMP07)',
        'English Creative Writing  (CW09)'
      ]
    },
    {
      weekNumber: 10,
      subjects: [
         'Maths - Algebra Part 01 (Basics) (M10)',
        'Creative Writing  (CW10)',
        'Reasoning - Verbal & Non Verbal (VRNVR03)'
      ]
    },
    {
      weekNumber: 11,
      subjects: [
        'Maths - Sequences, Distance, Speed, Time, Temperature  (M11)',
        'English Reading Comprehension (ECOMP08)',
        'English Creative Writing (CW11)'
      ]
    },
    {
      weekNumber: 12,
      subjects: [
        'Maths - Data Handling Part 02 (Advanced) (M12)',
        'English Creative Writing (CW12)',
        'Reasoning - Verbal & Non Verbal (VRNVR04)'
      ]
    },
    {
      weekNumber: 13,
      subjects: [
        'Maths - Shapes, Area, Perimeter & Volume Part 02 (Advanced) (M13)',
        'English Reading Comprehension (ECOMP09)',
        'English Creative Writing (CW13)'
      ]
    },
    {
      weekNumber: 14,
      subjects: [
        'Maths - Algebra Part 02 (Advanced) (M14)',
        'English Reading Comprehension (ECOMP10)',
        'English Creative Writing (CW14)'
      ]
    },
    {
      weekNumber: 15,
      subjects: [
        'Maths - ALL Topics (M15)',
        'English Creative Writing (CW15)',
        'Reasoning - Verbal & Non Verbal (VRNVR05)'
      ]
    }
  ];


  stories: SuccessStory[] = [
    {
      image: 'assets/images/malik-ali.jpeg',
      label: 'SEHYOG Student',
      name: 'Malik Ali Abbas',
      achievement: 'Who achieved the highest Score (411.89) in the Essex 11 Plus CSSE Exam 2025',
      testimonialHeader: 'Parents Shared this message after his Success',
      testimonial: '"I would like to sincerely thank Sehyog forthe constant support, excellent teaching, and motivation that helped me achieve greatresults in my CSSE and QE. I\'m truly grateful to all the teachers and staff who guided me throughout this journey. Your dedication made a big difference in my learning and success. Thank you for believing in me!"',
      closingMessage: 'We\'re proud of Malik\'s achievement - and we\'d love to help your child reach their full potential, too.'
    },
  ];


  pricingPlans: PricingPlan[] = [
    {
      weeks: '05',
      features: [
        '5 Hour Online Class',
        '10 Papers (Face 2 Face/Online)',
        '5 Hours - Doubt Clearing Sessions',
        'Result Analysis Report',
        'Student Papers and Keys'
      ],
      originalPrice: 100,
      discount: '10 % OFF',
      finalPrice: 90
    },
    {
      weeks: '07',
      features: [
        '7 Hours - Online Class',
        '14 Papers (Face 2 Face or Online)',
        '7 Hours - Doubt Clearing Sessions',
        'Result Analysis Report',
        'Student Papers andKeys',
      ],
      originalPrice: 140,
      discount: '15 % OFF',
      finalPrice: 119
    },
    {
      weeks: '15',
      features: [
        '15 Hours - Online Class',
        '35 Papers (Face 2 Face or Online)',
        'Additional Revision Papers',
        '15 Hours - Doubt Clearing Sessions',
        'Result Analysis Report',
        'Student Papers and Keys'
      ],
      originalPrice: 300,
      discount: '30 % OFF',
      finalPrice: 210
    }
  ];


  constructor() { }

  ngOnInit() {
  }

   downloadBrochure() {
    window.location.href = "https://drive.google.com/uc?export=download&id=1r__EYfdorvkDGR10G9MrUxY0mzwuPYQ0";
  }

}
